module.exports = __webpack_public_path__ + "media/connect_car_cable.10e19a16.mp4";